// extracted by mini-css-extract-plugin
export default {"faqWhoShowInSearch":"faqWhoShowInSearch_J50zs","title":"title_YEjJ8","content":"content_rHEGn","list":"list_YZKpV","item":"item_vrzW4","picture":"picture_Pewpw"};